import { Component, HostListener } from '@angular/core';
import { SidebarService } from './shared/services/sidebar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'cashjaradmin-web';

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.sidebarService.isTriggerExpandHideSidebar.next(true);
  }
  
  constructor(private sidebarService: SidebarService) {

  }
}
